// extracted by mini-css-extract-plugin
export default {"chip":"LhpOr","image":"fSt9s"};